import React from 'react';
import { Link } from 'react-router-dom';
import { getCategoryByCode } from '../helper/catalogCategories';

const AdminBreadcrumb = ({ catalog, product, currentAction }) => {
    const category = catalog ? getCategoryByCode(catalog.categoryCode) : null;

    return (
        <div className="bg-white border-bottom py-10 px-16 shadow-2xs mb-20">
            <div className="container container-lg">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb mb-0 align-items-center text-xs fw-semibold">
                        {/* Level 1: Dashboard / Catalogs */}
                        <li className="breadcrumb-item d-flex align-items-center">
                            <Link to="/admin/dashboard" className="text-gray-600 hover-text-main-600 flex-align gap-6 text-decoration-none">
                                <i className="ph ph-squares-four text-sm text-main-600"></i>
                                <span>Catálogos</span>
                            </Link>
                        </li>

                        {/* Level 2: Catalog Name */}
                        {catalog && (
                            <li className={`breadcrumb-item d-flex align-items-center ${!product && !currentAction ? 'active text-gray-900 fw-bold' : ''}`}>
                                {(!product && !currentAction) ? (
                                    <span className="flex-align gap-6">
                                        <span className="w-10 h-10 rounded-circle" style={{ backgroundColor: catalog.color || category?.defaultColor }}></span>
                                        {catalog.name}
                                    </span>
                                ) : (
                                    <Link to={`/admin/dashboard/${catalog.id}`} className="text-gray-600 hover-text-main-600 flex-align gap-6 text-decoration-none">
                                        <span className="w-10 h-10 rounded-circle" style={{ backgroundColor: catalog.color || category?.defaultColor }}></span>
                                        <span>{catalog.name}</span>
                                    </Link>
                                )}
                            </li>
                        )}

                        {/* Level 3: Product Name or Action */}
                        {product && (
                            <li className={`breadcrumb-item d-flex align-items-center ${!currentAction ? 'active text-gray-900 fw-bold' : ''}`}>
                                {!currentAction ? (
                                    <span>{product.name}</span>
                                ) : (
                                    <Link to={`/admin/dashboard/${catalog.id}/${product.id}`} className="text-gray-600 hover-text-main-600 text-decoration-none">
                                        {product.name}
                                    </Link>
                                )}
                            </li>
                        )}

                        {/* Level 4: Action (New / Edit) */}
                        {currentAction && (
                            <li className="breadcrumb-item active text-main-600 fw-bold" aria-current="page">
                                {currentAction}
                            </li>
                        )}
                    </ol>
                </nav>
            </div>
        </div>
    );
};

export default AdminBreadcrumb;
